module.exports = __webpack_public_path__ + "img/01.70c7e542.jpg";